import type { PublicApiKey } from '#packages/apilib';
import type { createTextEditorApi } from './textEditorApi';

export const TextEditorApiKey: PublicApiKey<typeof createTextEditorApi> = {
  name: 'TextEditorApi',
  public: true,
};
